import React, { useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import { AuthProvider } from './AuthContext';
import './index.css';
import App from './App';
import i18n from './locales/i18n';
import { OidcProvider, OidcSecure, useOidc } from "@axa-fr/react-oidc";
import app_env from './utils/app-config.json';
import { fetchConfigarationData, retrieveData } from './helpers/utils/Utils';
import SweetAlert from './components/CustomComponents/SwalAlert';
import Loader from './components/CustomComponents/Loader';
import { clearStorageExceptKey } from './utils';
import { Provider, useSelector } from 'react-redux';
import { store } from './Redux/store';
import { ISDEV_ENV, PREFERRED_IDENTITY_SERVICE_URL, STATUS_SUCCESS_CODE , GET_DEVICE_TOKEN} from './network/URLConstants';
import warningImg from './assets/images/warning.png'
import { Navigate } from 'react-router';
import { t } from 'i18next';
import { GetApiHeadersWithOutBearer, PostRequest , GetRequest} from './network/NetworkUtils';
import Cookies from 'js-cookie';
import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';



const appConfigData = await fetchConfigarationData();

datadogRum.init({
  applicationId: '3e11f32c-97cc-44bd-af4f-15350fcc3093',
  clientToken:   'pubddfe2bca1db6f29cf2d7865ef7559df0',
  site:           'us3.datadoghq.com',
  service:       appConfigData.DATADOG_SERVICE_NAME,
  env:           appConfigData.DATADOG_ENV,
  sessionSampleRate:       100,
  sessionReplaySampleRate: 20,
  defaultPrivacyLevel:     'mask-user-input',
  plugins: [reactPlugin({ router: false })],
});

datadogRum.onReady(() => {
  console.log('Init config:', datadogRum.getInitConfiguration())
  const ctx = datadogRum.getInternalContext()
  console.log('Internal context:', ctx)
  // ctx.application_id, ctx.session_id, ctx.view.id, etc.
})

//global.isLoggedIn = false;

if (!ISDEV_ENV) {
  // Disable console logs in production
  console.log = function () { };
  console.warn = function () { };
  console.error = function () { };
} 
var configuration;
//  = {
//   // prompt: appConfigData.PROMPT,
//   client_id: appConfigData.CLIENT_ID,
//   redirect_uri: appConfigData.REDIRECT_URI,
//   post_logout_redirect_uri: appConfigData.POST_LOGOUT_REDIRECT_URI,
//   silent_redirect_uri: appConfigData.SILENT_REDIRECT_URI,
//   scope: appConfigData.TWO_FACT_SCOPE, 
//   authority: appConfigData.AUTH_URL,
//   extras: { usc: appConfigData.USER_SCOPE, response_mode: "query",prompt: appConfigData.PROMPT },
//   token_request_extras: { client_secret: appConfigData.CLIENT_SECRET},
//   monitor_session: false,
//   // service_worker_relative_url: "/OidcServiceWorker.js",
//   refresh_time_before_tokens_expiration_in_second: appConfigData.REFRESH_TIME_BEFORE_TOKENS_EXPIRATION_IN_SECOND,
//   service_worker_only: true,
//   storage: sessionStorage, //if it not working need to change to local storage so user can access local storage
//   token_renew_mode: 'access_token_invalid',
//   logout_tokens_to_invalidate: []
// };

const Authenticating = () => { <Loading /> };

const Loading = () => { <Loading />

    const redirectTologinFrommicrosoft = () => {
      const currentUrl = window.location.href;
      if (currentUrl.includes('access_denied') && currentUrl.includes('error_description=AADB2C90091')) {
          window.location.replace(origin); 
          const errorIndex = currentUrl.indexOf('error');
          const errorContent = currentUrl.substring(errorIndex);
          console.log('Error from authentication:', errorContent);  
      } 
        else if (currentUrl.includes('error')) {
         window.location.replace(origin);   
         const errorIndex = currentUrl.indexOf('error');
          const errorContent = currentUrl.substring(errorIndex);
          console.log('Error from authentication:', errorContent);
       } 
      }
    
      useEffect(() => {
        redirectTologinFrommicrosoft();
      }, [window.location.pathname]);
 };

const handleModalOK = () => {
  const deviceIdKey = 'updatedDeviceId';
  clearStorageExceptKey(sessionStorage, deviceIdKey);
  clearStorageExceptKey(localStorage, deviceIdKey);
  window.location.href = window.location.origin
};

const CallBackSuccess = () => <Loading />
  


const AuthenticatingError = () => {
  const kudzuPlusTrue = false;
  const { logout } = useOidc();

  return (
    <div className="fixed inset-0 flex items-center justify-center scrollable-container-home loaded h-auto w-full bg-[#262B3A]"
      style={{ zIndex: 100, minHeight: '600px' }}>
      <div className="modal-overlay fixed inset-0 bg-[var(--modalcard-overlay)] transition-opacity"
        style={{ minHeight: '600px' }} />

      <div
        // ref={modalRef}
        className={
          `modal-container bg-[#FEFAEE] sm:rounded-tl-card-tr sm:rounded-br-card-bl md:w-[778px] sm:w-[466px] w-[100%] mx-auto shadow-lg z-50 transition-all duration-300  ease-in-out `}>
        <div className='w-full h-full'>
          <div className='flex flex-col items-center self-center justify-between h-full w-full '>
            <div className='flex justify-end items-end w-11/12 lg:mt-10 md:mt-8 sm:mt-5 mt-10'
              tabIndex={0}
              onKeyDown={(event) => {
                if (event.key == "Enter") {
                  event.preventDefault();
                 logout().then(() => handleModalOK())
                }
              }}
              onClick={(event) => {
                logout().then(() => handleModalOK())
              }}>
              <button className="modal-close text-gray-500 hover:text-gray-800 cursor-pointer" >
                <svg xmlns="http://www.w3.org/2000/svg"
                  className="h-[1rem] w-[1rem] opacity-[60%]"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor" >
                  <path strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
              </button>
            </div>

            <div className='pt-5 w-3/5'>
              <span className='font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal text-[#2965FB]'>{t('Oops!')} </span>
              <span className={`font-serif-pro modal-title ${kudzuPlusTrue ? 'text-white' : 'text-black'} lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal`}>{t('Something_went_wrong_erroe')}</span>
            </div>
            <div className='w-full mt-5 flex flex-col items-center'>
              <img
                src={warningImg}
                // alt="Image"
                className="lg:w-[120px] lg:h-[120px] md:w-[100px] md:h-[100px] sm:w-[92px] sm:h-[92px] w-[120px] h-[120px]"
              />
            </div>
            <div className='lg:pt-20 md:pt-18 sm:pt-10 lg:mb-20 md:mb-20 sm:mb-8 mb-20 pt-16 w-3/5 '>
              <button className='lg:text-[16px] md:text-[14px] sm:text-[13px] text-[14px] w-full border-2 border-[#2965FB] lg:h-[60px] md:h-[55px] sm:h-[50px] h-[55px] text-white font-hanken-grotesk font-bold leading-[16px] disabled:opacity-30'
                style={{ backgroundColor: '#2965FB' }}
                tabIndex={0}
                onKeyDown={(event) => {
                  if (event.key === "Enter") {
                    event.preventDefault();
                    logout().then(() => handleModalOK());
                  }
                }}
                onClick={(event) => { event.target.style.opacity = 0.8; logout().then(() => { handleModalOK(); setTimeout(() => { event.target.style.opacity = 1; }, 200);}); }}>Try again</button>
            </div>
          </div>

        </div>

      </div>
    </div >
  );
}


if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/firebase-messaging-sw.js')
      .then((registration) => {
      })
      .catch((error) => {
      });
  });
}

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);
const MainApp = () => { 
  const pathSegments = window.location.pathname;
  
  const urlParams = new URLSearchParams(window.location.search);
  const smiOneIdFromUrl = urlParams.get("id");
  const finalUrl = pathSegments.includes("smione-experience-migration") 
  const isSMI = pathSegments.includes("link-smione-card/Onboard") || pathSegments.includes("link-smione-card");
  const link = pathSegments.includes("link-smione-card")
 
  if (finalUrl && smiOneIdFromUrl && smiOneIdFromUrl !== null) {
    store.dispatch({ type: 'SMI_ONE_ID', payload: { smiOneId: smiOneIdFromUrl} }); 
    const MigrationTokenForCookies = `MigrationTokenCookie`;
    Cookies.set(MigrationTokenForCookies, smiOneIdFromUrl, { expires: 1825 });
  }
  
  // if (link) {


  //     window.history.pushState({}, "", "link-smione-card/Onboard");
  // }
 

  if(finalUrl){ 
    store.dispatch({ type: 'FROM_SMI_ONE', payload: { fromSmiOne: finalUrl} });
    window.history.pushState({}, "", "/signup");
  }
  const [isApiLoaded, setIsApiLoaded] = useState(false);
 
  useEffect(() => {
    
    // Make the API call
    const makeApiCall = async () => {
      const appConfigData = await fetchConfigarationData();
      const deviceId = await retrieveData('updatedDeviceId');
      const headers = await GetApiHeadersWithOutBearer(deviceId);
      let deviceTokenResp = null;
      try {
        const deviceTokenResponse = await GetRequest(GET_DEVICE_TOKEN, headers);
        let responseObj = JSON.parse(deviceTokenResponse);
        if (responseObj.ResponseCode === STATUS_SUCCESS_CODE) {
          deviceTokenResp = responseObj.Response.deviceToken;
        }
      } catch (e) {
      }

      let request = {
        applicationId: appConfigData.APP_CLIENT_ID,
        product: "kudzu",
        version: appConfigData.APP_VERSION,
       };
        const response = await PostRequest(PREFERRED_IDENTITY_SERVICE_URL, request, headers);
        let responseObj = JSON.parse(response);
        if (responseObj.ResponseCode == STATUS_SUCCESS_CODE) {
          const data = responseObj.Response.PreferredIdentityService == "B2C"
          store.dispatch({ type: 'PREFERRED_IDENTITY_SERVICE', payload: { preferredIdentity: data } });
          store.dispatch({type:'B2C_ENABLED', payload: {b2cEnabled: responseObj.Response.IsB2CMFAEnable}});
          const appConfigDataUpdated = await fetchConfigarationData(true);

          setTimeout (() => { 
            configuration = {
              // prompt: appConfigData.PROMPT,
              client_id: data ? appConfigDataUpdated.CLIENT_ID_B2C : appConfigDataUpdated.CLIENT_ID  ,
              redirect_uri: isSMI ?  appConfigDataUpdated.SMI_REDIRECT_URI : appConfigDataUpdated.REDIRECT_URI,
              post_logout_redirect_uri: appConfigDataUpdated.POST_LOGOUT_REDIRECT_URI,
              silent_redirect_uri: appConfigDataUpdated.SILENT_REDIRECT_URI,
              scope: appConfigDataUpdated.TWO_FACT_SCOPE, 
              authority: appConfigDataUpdated.AUTH_URL,
              extras: { usc: appConfigDataUpdated.USER_SCOPE, response_mode: "query",prompt: appConfigDataUpdated.PROMPT,dark_mode:appConfigDataUpdated.DARK_MODE,deviceToken:deviceTokenResp},
              token_request_extras: { client_secret: appConfigDataUpdated.CLIENT_SECRET},
              monitor_session: false,
              // service_worker_relative_url: "/OidcServiceWorker.js",
              refresh_time_before_tokens_expiration_in_second: appConfigDataUpdated.REFRESH_TIME_BEFORE_TOKENS_EXPIRATION_IN_SECOND,
              service_worker_only: true,
              storage: sessionStorage, //if it not working need to change to local storage so user can access local storage
              token_renew_mode: 'access_token_invalid',
              logout_tokens_to_invalidate: []
            };
           setIsApiLoaded(true);
          }, 500);
          // const configuration = await initializeAppConfig();
          console.log('API response:', responseObj);   
        }
    };
    makeApiCall()
  
  }, []);

  if (!isApiLoaded) {
    // Show a loading component while waiting for the API call to complete
    return <Loader />;
  }

  return (
    <OidcProvider
      authenticatingComponent={Authenticating}
      onLogoutFromAnotherTab={handleModalOK}
      authenticatingErrorComponent={AuthenticatingError}
      sessionLostComponent={AuthenticatingError}
      loadingComponent={Loading}
      serviceWorkerNotSupportedComponent={AuthenticatingError}
      callbackSuccessComponent={CallBackSuccess}
      configuration={configuration}
      onSessionLost={() => console.log('sessionLost')}
    >
      <AuthProvider>
        <I18nextProvider i18n={i18n}>
          <Provider store={store}>
            <App />
          </Provider>
        </I18nextProvider>
      </AuthProvider>
    </OidcProvider>
  );
};

root.render(<MainApp />);